// import config
import { toast } from "react-hot-toast";
import axios from "../Config/axios";

// import lib
import { setWalletAddress } from "../lib/localStorage";
import { WALLET_ADDRESS } from "./types";
import { userPlanDetail } from "../Hooks/UseContract";

// export const addNewUser = async (data, dispatch) => {
//   try {
//     console.log(data, "addNewUser");
//     let respData = await axios({
//       method: "post",
//       url: `/userapi/addNew-User`,
//       data,
//     });
//     console.log(respData, "respData");
//     if (respData.data && !respData.data?.data?.status) {
//       toast.error("Sorry. The address is not Whitelisted yet!");
//       localStorage.clear();
//       return sessionStorage.clear();
//     }
//     setWalletAddress(data.walletAddress);
//     sessionStorage.setItem("user",JSON.stringify(userInfo));
//     dispatch({
//       type: WALLET_ADDRESS,
//       payload: data.walletAddress,
//     });
//     return {
//       status: "success",
//       loading: false,
//       message: respData.data.message,
//       data: respData.data.data,
//     };
//   } catch (err) {
//     return {
//       status: "failed",
//       loading: false,
//       message: err.response.data.message,
//       error: err.response.data.errors
//     };
//   }
// };

export const addNewUser = async (data, dispatch) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/userapi/addNew-User`,
      data,
    });

    // if (respData.data && !respData.data?.data?.status) {
    //   toast.error("Sorry. The address is not Whitelisted yet!");
    //   localStorage.clear();
    //   return sessionStorage.clear();
    // }
    const userInfo = respData.data?.data;

    sessionStorage.setItem("user", JSON.stringify(userInfo));

    setWalletAddress(data.walletAddress);
    dispatch({
      type: WALLET_ADDRESS,
      payload: data.walletAddress,
    });
    return {
      status: respData.data.status,
      loading: false,
      message: respData.data.message,
      data: respData.data.data,
    };
  } catch (err) {
    return {
      status: err?.respData?.data?.status,
      loading: false,
      message: err?.respData?.data?.message,
      error: err?.respData?.data?.errors
    };
  }
};

export const checkExpired = async (info) => {
  // var s = {
  //   years: 31536000,
  //   months: 2592000,
  //   weeks: 604800, // uncomment row to ignore
  //   days: 86400, // feel free to add your own row
  //   hours: 3600,
  //   minutes: 60,
  //   seconds: 1,
  // };

  // const purchasedOn =
  //   new Date(info?.createdAt).getTime() / 1000 +
  //   s[String(info?.validity).toLocaleLowerCase()];
  // console.log(
  //   "purchasedOn : ",
  //   new Date(info?.createdAt).getTime() / 1000,
  //   s[String(info?.validity).toLocaleLowerCase()],
  //   "PURCHASED ON ",
  //   purchasedOn,
  //   "NOW : ",
  //   Date.now() / 1000,
  //   "CONFITIPNN : ",
  //   Date.now() / 1000 >= purchasedOn
  // );
  let planData = await userPlanDetail(info)
  return Date.now() < new Date(Number(planData.validTill) * 1000).getTime()
};

export const getUserPlans = async (data) => {

  console.log("getAllUserPlans", data);

  try {
    let respData = await axios({
      method: "post",
      url: `/currencyapi/get-all-subscription-plan`,
      data
    });
    return {
      status: "success",
      loading: false,
      message: respData.data.message,
      result: respData.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
      data: null,
    };
  }
};

export const getUserDashData = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/userapi/user-dashboard-data`,
      data,
    });
    return {
      status: "success",
      loading: false,
      message: respData?.data?.message,
      result: respData?.data?.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
      data: null,
    };
  }
};


export const getUserBycode = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/userapi/userbycode`,
      data,
    });
    return {
      status: "success",
      loading: false,
      message: respData?.data?.message,
      result: respData?.data?.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
      data: null,
    };
  }
};



export const addUserPlans = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/userapi/user-buy-plan`,
      data,
    });
    console.log("🚀  addUserPlans  respData:", respData.data.message)
    return {
      status: "success",
      loading: false,
      message: respData.data.message,
      result: respData.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
      data: null,
    };
  }
};



export const getCommissions = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/userapi/commission-details`,
      data,
    });

    console.log("getCommissionsgetCommissions", respData);

    return {
      status: respData.data.status,
      loading: false,
      message: respData.data.message,
      data: respData.data.data,
      count: respData.data.count,
    };
  } catch (err) {
    return {
      status: err?.respData?.data?.status,
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
      data: null,
    };
  }
};

export const getPlanData = async (data) => {

  console.log("getPlanDatagetPlanData", data);

  try {
    let respData = await axios({
      method: "post",
      url: `/userapi/get-user-plandata`,
      data,
    });

    console.log("respDatarespData", respData);

    return {
      status: respData.data.status,
      loading: false,
      message: respData.data.message,
      data: respData.data.data,
    };
  } catch (err) {
    return {
      status: err?.respData?.data?.status,
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
      data: null,
    };
  }
};


export const userWithdrawAmount = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/userapi/userWithdraw`,
      data,
    });
    return {
      status: respData.data.status,
      loading: false,
      message: respData.data.message,
      data: respData.data.data,
    };
  } catch (err) {
    return {
      status: err?.respData?.data?.status,
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
      data: null,
    };
  }
};



export const subscribeUser = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/userapi/subscribe`,
      data,
    });
    return {
      status: respData.data.status,
      loading: false,
      message: respData.data.message,
      data: respData.data.data,
    };
  } catch (err) {
    return {
      status: err?.respData?.data?.status,
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
      data: null,
    };
  }
};

